import { Link } from "react-router-dom";

const entries = [
  {
    label: "电影",
    desc: "两小时讲完一件事",
    icon: "ri-film-line",
    to: "/category?type=电影",
  },
  {
    label: "电视剧",
    desc: "慢慢展开的长故事",
    icon: "ri-tv-2-line",
    to: "/category?type=电视剧",
  },
  {
    label: "国产",
    desc: "华语创作的当下",
    icon: "ri-building-4-line",
    to: "/category?region=国产",
  },
  {
    label: "海外",
    desc: "来自世界的故事",
    icon: "ri-earth-line",
    to: "/category?region=海外",
  },
  {
    label: "热门推荐",
    desc: "本周讨论度最高",
    icon: "ri-fire-line",
    to: "/category?tag=热门推荐",
  },
];

export default function QuickCategories() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-6 md:px-6 md:py-7">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {entries.map((entry) => (
            <Link
              key={entry.label}
              to={entry.to}
              className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-100/60 px-3 py-3 transition-colors hover:border-accent-400 hover:bg-accent-50"
            >
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
                <i className={`${entry.icon} text-lg`} />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-foreground-900">{entry.label}</span>
                <span className="mt-0.5 block truncate text-[11px] text-foreground-500">{entry.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}